/**
 * Operations Settings Page
 * Admin settings for operations features
 */

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft, Settings } from 'lucide-react';
import { OperationsPermissionsManager } from '../components/settings/OperationsPermissionsManager';

export function OperationsSettingsPage() {
  const { t } = useTranslation('operations');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center gap-4">
          <Link
            to="/operations/tasks"
            className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            {t('settings.backToOperations')}
          </Link>
        </div>
        <div className="mt-4 flex items-center gap-3">
          <div className="p-2 bg-gray-100 rounded-lg">
            <Settings className="h-6 w-6 text-gray-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              {t('settings.title')}
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              {t('settings.subtitle')}
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-6 py-8">
        <OperationsPermissionsManager />
      </div>
    </div>
  );
}
